import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { Field, Form, Formik } from "formik";
import { AntInput, AntNumber, AntTextArea } from "../../../hooks/createAntDFields";
import axios from "axios";
import { toast } from "react-toastify";
import REACT_APP from "../../../environment";
import { useDispatch } from "react-redux";
import { endWait, startWait } from "../../../store/waiting";
import { productTypeInitialValue, productTypeValidation } from "../../../constants/product";
import { useTranslation } from "react-i18next";

const UpdateProductType = ({ productType, isModalOpen, setIsModalOpen, getData }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const validate = productTypeValidation(t);

    const cancel = (resetForm) => {
        if (typeof resetForm === "function") resetForm();
        setIsModalOpen(false);
    };

    const submit = async (data, { setSubmitting, resetForm }) => {
        dispatch(startWait());
        delete data.status;
        await axios
            .put(`${REACT_APP.API_URL}/api/hrp/provider/v1/product/type`, data, { headers: { Authorization: sessionStorage.getItem("token") } })
            .then(() => {
                resetForm();
                toast.success(t("Updated!"));
                getData();
                setIsModalOpen(false);
            })
            .catch((err) => {
                console.log(err);
                toast.error(t((err.response?.data?.errors && err.response.data.errors[0]?.message) || err.message));
            });
        dispatch(endWait());
        setSubmitting(false);
    };

    return (
        <Formik initialValues={productType || productTypeInitialValue} enableReinitialize validationSchema={validate} onSubmit={submit}>
            {({ isSubmitting, submitCount, errors, values, resetForm }) => (
                <Modal title={t("Update product type")} open={isModalOpen} footer={[]} onCancel={() => cancel(resetForm)}>
                    <div className="pt-4">
                        <Form autoComplete="off">
                            <div>
                                <label htmlFor="name">{t("Product type name")}</label>
                                <Field component={AntInput} submitCount={submitCount} size="large" name="name" />
                                <div className="grid gap-2 grid-cols-2">
                                    <div>
                                        <label htmlFor="insurance_amount">{t("Insurance amount")}</label>
                                        <Field component={AntNumber} submitCount={submitCount} size="large" name="insurance_amount" />
                                    </div>
                                    <div>
                                        <label htmlFor="deductable_amount">{t("Deductable amount")}</label>
                                        <Field component={AntNumber} submitCount={submitCount} size="large" name="deductable_amount" />
                                    </div>
                                </div>
                                <label htmlFor="description">{t("Description")}</label>
                                <Field
                                    component={AntTextArea}
                                    submitCount={submitCount}
                                    size="large"
                                    name="description"
                                    autoSize={{ minRows: 3, maxRows: 5 }}
                                />
                            </div>
                            <div className="ant-modal-footer">
                                <Button onClick={() => cancel(resetForm)}>{t("Cancel")}</Button>
                                <Button type="primary" htmlType="submit">
                                    {t("Submit")}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal>
            )}
        </Formik>
    );
};
export default UpdateProductType;
